import { usePathBreakdown } from '@/lib/hooks/usePathBreakdown';

export const useActiveResourceFromPath = () => {
  const pathBreakdown = usePathBreakdown();
  const [learn, learnName] = pathBreakdown;
  if (learn !== 'learn')
    throw new Error('This hook can only be used on a learn path');
  return learnName;
};
